<template>
  <section>
    <b-modal width="680px" :active.sync="isModalTagCollectEditActive" :on-cancel="closeTagCollectEditModal">
      <div class="card" style="border-radius: 5px;">
          <!-- タグ編集エリア -->
          <TemplateTagEdit
            :isTagProgress="isTagProgress"
            :currentTagList="currentTagList"
            :defaultTagList="defaultTagList"
            :isError="isError"
            :errorTitle="errorTitle"
            :errorMessage="errorMessage"
            @addTag="collectAddTag"
            @deleteTag="collectDeleteTag"
            @errorClear="errorClear"
          />
        <!-- コンテンツ選択エリア -->
        <div class="card-content scroll-box">
          <!-- ページ番号 -->
          <div class="tab-header" style="padding-bottom: 12px;" v-if="getIsRecruit">
            <b-pagination
              :total="countContents"
              :current.sync="pages"
              :per-page="perPage">
            </b-pagination>
          </div>
          <!-- 個別選択 -->
          <div style="position: relative; overflow-y: scroll; max-height: 360px;">
            <!-- ローディングページ -->
            <div class="init-page" style="background: transparent;" v-if="isLoading">
              <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
            </div>
            <div v-else>
              <!-- 一括選択 -->
              <template>
                <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                  <b-checkbox v-model="isAllSelected" @input="getAllUrl()"><b>全URLに適用する</b></b-checkbox>
                </p>
              </template>
              <template v-for="(sitemap, index) in sitemapContentList">
                <!-- 求人ページ -->
                <p class="url-list" v-if="sitemap.contents && (sitemap.contents.layout == 4)"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox v-model="selectSitemapList" :native-value="sitemap">
                    <Tooltip :message="getTagList(sitemap)">
                      {{sitemap.contents.content.title}}
                    </Tooltip>
                 </b-checkbox>
                </p>
                <!-- カスタムページ -->
                <p class="url-list" v-else-if="sitemap.contents && (sitemap.contents.layout == 5)"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox v-model="selectSitemapList" :native-value="sitemap">
                    <Tooltip :message="getTagList(sitemap)">
                      {{sitemap.contents.title}}
                    </Tooltip>
                  </b-checkbox>
                </p>
                <!-- ホームページ -->
                <p class="url-list" v-else
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox v-model="selectSitemapList" :native-value="sitemap">
                    <Tooltip :message="getTagList(sitemap)">
                      {{sitemap.node_url}}
                    </Tooltip>
                  </b-checkbox>
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
// 外部関数
import {
  /** ページ情報初期値 */
  SITEMAP_OVERALL,
  /** ページ種別定義 */
  SITEMAP_PAGE_TYPE,
  /** コンテンツ種別 */
  SITEMAP_CONTENT_TYPE,
} from '@/functions/users/sitemapFunc'

import Tooltip          from '@/components/atoms/tooltips/Tooltip'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import TemplateTagEdit  from '@/components/organisms/templates/TemplateTagEdit'
import {
    /** アラートダイアログ用定義 */
    ALERT_DEF,
    /** アラートダイアログ用データ作成 */
    createAlertData
} from '@/functions/common/alertFunc'

export default {
  name: 'ModalTagCollectEdit',
  componentName: 'ModalTagCollectEdit',
  components: {
    Tooltip,
    ModalAlertDialog,
    TemplateTagEdit
  },
  computed: {
    getIsRecruit () {
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        return true
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      /** モーダルダイアログ開閉フラグ */
      isModalTagCollectEditActive: this.isTagCollectEditModalOpen,
      /** 全選択フラグ */
      isAllSelected              : false,
      /** 読み込み中フラグ */
      isLoading                  : false,
      /** 選択済みコンテンツリスト */
      selectSitemapList          : [],
      /** コンテンツタイプ */
      contentsType               : SITEMAP_CONTENT_TYPE.RECRUIT_PAGE,
      /** 表示中ページ番号 */
      pages                      : SITEMAP_OVERALL.PAGES,
      /** ページ内表示件数 */
      perPage                    : SITEMAP_OVERALL.PER_PAGE,
      /** 表示コンテンツリスト */
      sitemapContentList         : [],
      /** コンテンツ総数 */
      countContents              : 0,
      /** アラートダイアログ開閉フラグ */
      isAlertDialogOpen          : false,
      /** アラートダイアログ表示データ */
      alertData                  : {},
      /** エラーフラグ */
      isError                    : false,
      /** エラータイトル */
      errorTitle                 : '',
      /** エラーメッセージ */
      errorMessage               : ''
    }
  },
  props: {
    /** 一括タグ編集モーダル開閉フラグ */
    isTagCollectEditModalOpen: {
      type    : Boolean,
      default : false,
      required: true
    },
    /** タグ編集中フラグ */
    isTagProgress : {
      type    : Boolean,
      default : false,
      required: true
    },
    /** ページ種別 */
    pageType: {
      type    : String,
      default : SITEMAP_PAGE_TYPE.RECRUIT_PAGE,
      required: true
    },
    /** 全求人ページリスト */
    sitemapRecruitListAll: {
      required: true
    },
    /** 全カスタムページリスト */
    sitemapCustomListAll: {
      required: true
    },
    /** 選択中サイトマップルート */
    selectedSitemapRoot: {
      required: true
    },
    /** 親オブジェクト */
    targetObj: {
      required: false
    },
    /** デフォルトタグリスト */
    defaultTagList: {
      required: true
    },
    /** 親タグリスト */
    currentTagList: {
      required: true
    }
  },
  mounted () {
    /** コンテンツリスト表示 */
    this.dispList()
  },
  watch: {
    /** 一括タグ編集モーダル開閉フラグ */
    isTagCollectEditModalOpen () {
      this.isModalTagCollectEditActive = this.isTagCollectEditModalOpen
    },
    /** 全求人ページリスト */
    sitemapRecruitListAll () {
      /** コンテンツリスト再表示 */
      this.dispList()
      this.isLoading = false
    },
    /** 全カスタムページリスト */
    sitemapCustomListAll () {
      /** コンテンツリスト再表示 */
      this.dispList()
      this.isLoading = false
    },
    selectedSitemapRoot () {
      /** コンテンツリスト再表示 */
      this.dispList()
      this.isLoading = false
    },
    /** 表示中ページ数 */
    pages () {
      /** コンテンツリスト再表示 */
      this.dispList()
    }
  },
  methods: {
    /** コンテンツ別タグリスト取得 */
    getTagList (sitemap) {
      let tagList = []
      if (sitemap.tag_list.length > 0) {
        for(const tag of sitemap.tag_list) {
          tagList.push('・' + tag.name)
        }
        return tagList.join('\n')
      } else {
        return 'タグ設定なし'
      }
    },
    /** コンテンツリスト表示 */
    dispList () {
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        // 求人ページ
        const start = (this.pages -1) * this.perPage
        const end   = ((this.pages -1) * this.perPage) + this.perPage
        this.sitemapContentList = this.sitemapRecruitListAll.slice(start, end)
        this.countContents      = this.sitemapRecruitListAll.length
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページ
        const start = (this.pages -1) * this.perPage
        const end   = ((this.pages -1) * this.perPage) + this.perPage
        this.sitemapContentList = this.sitemapCustomListAll.slice(start, end)
        this.countContents      = this.sitemapCustomListAll.length
      } else {
        // ホームページ
        if (this.selectedSitemapRoot) {
          this.sitemapContentList = this.selectedSitemapRoot.node_list
          this.countContents      = 0
        }
      }
    },
    /** タグ一括追加 */
    collectAddTag (targetObj, addTagName) {
      if (!this.isAllSelected && this.selectSitemapList.length <= 0) {
        this.errorTitle = '対象ページの選択'
        this.errorMessage = '対象のページを1件以上選択してください。'
        this.isError = true
      } else {
        this.$emit('collectAddTag', this.isAllSelected, this.selectSitemapList, addTagName)
      }
    },
    /** タグ一括削除 */
    collectDeleteTag (delTagName) {
      if (!this.isAllSelected && this.selectSitemapList.length <= 0) {
        this.errorTitle = '対象ページの選択'
        this.errorMessage = '対象のページを1件以上選択してください。'
        this.isError = true
      } else {
        this.$emit('collectDeleteTag', this.isAllSelected, this.selectSitemapList, delTagName)
      }
    },
    /** エラー情報クリア */
    errorClear () {
      this.errorTitle = ''
      this.errorMessage = ''
      this.isError = false
    },
    /** 一括タグ編集モーダルクローズ */
    closeTagCollectEditModal () {
      this.$emit('closeTagCollectEditModal')
      this.isAllSelected = false
      this.selectSitemapList = []
    },
    /** エラーアラート表示 */
    alertError (title, message) {
      this.alertData = createAlertData(
          title,
          message,
          ALERT_DEF.MESSAGE_WARNING,
          ALERT_DEF.DIALOG_ALERT,
          'modal-collect-tag-edit'
      )
      this.isAlertDialogOpen = true
    },
    /** アラート結果取得 */
    alertResult (result) {
      if (result.alertKeyFunction === 'modal-collect-tag-edit') {
        this.isAlertDialogOpen = false
      }
    },
    /** 全選択 */
    getAllUrl () {
      if (this.pageType === SITEMAP_PAGE_TYPE.HOME_PAGE) {
        // ホームページ
        if (this.isAllSelected) {
          // 全選択
          this.selectSitemapList = this.$_.union(this.selectSitemapList, this.selectedSitemapRoot.node_list)
        } else {
          // 個別選択
          this.selectSitemapList = this.$_.difference(this.selectSitemapList, this.selectedSitemapRoot.node_list)
        }
      } else if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        // 求人ページ
        if (this.isAllSelected) {
          // 全選択
          this.selectSitemapList = this.$_.union(this.selectSitemapList, this.sitemapRecruitListAll)
        } else {
          // 個別選択
          this.selectSitemapList = this.$_.difference(this.selectSitemapList, this.sitemapRecruitListAll)
        }
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページ
        if (this.isAllSelected) {
          // 全選択
          this.selectSitemapList = this.$_.union(this.selectSitemapList, this.sitemapCustomListAll)
        } else {
          // 個別選択
          this.selectSitemapList = this.$_.difference(this.selectSitemapList, this.sitemapCustomListAll)
        }
      }
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/users/sitemap/ModalTagCollectEdit.vue